import { render } from "./DetailGroup.vue?vue&type=template&id=4f9f189c&scoped=true"
import script from "./DetailGroup.vue?vue&type=script&lang=js"
export * from "./DetailGroup.vue?vue&type=script&lang=js"

import "./DetailGroup.vue?vue&type=style&index=0&id=4f9f189c&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f9f189c"]])

export default __exports__